import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Handles the #session_id fragment Emergent Auth sends us back on.
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("Sign-in could not be completed.");
        const data = await res.json();
        onLogin(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Google sign-in failed:", e);
        setError("That sign-in link has expired. Please try again.");
      }
    };
    exchange();
  }, [navigate, onLogin]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "var(--mp-paper)" }}
      data-testid="auth-callback"
    >
      <div className="text-center">
        {error ? (
          <>
            <p
              className="text-sm mb-4"
              style={{ color: "var(--mp-text)", fontFamily: "'Manrope', sans-serif" }}
              data-testid="auth-callback-error"
            >
              {error}
            </p>
            <button
              onClick={() => navigate("/login", { replace: true })}
              data-testid="auth-callback-retry"
              className="text-sm px-5 py-2.5 rounded-sm"
              style={{ backgroundColor: "var(--mp-copper-solid)", color: "#FFFFFF", fontFamily: "'Manrope', sans-serif" }}
            >
              Back to sign in
            </button>
          </>
        ) : (
          <p
            className="flex items-center gap-2 text-sm"
            style={{ color: "var(--mp-muted)", fontFamily: "'Manrope', sans-serif" }}
          >
            <Loader2 className="w-4 h-4 animate-spin" /> Signing you in&hellip;
          </p>
        )}
      </div>
    </div>
  );
}
